<template>
  <div class="conteudoInterno" id="diretor-operacoes">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
    </div>
    <header class="headerSec">
      <h2>Análise do nosso diretor de operações</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
      </div> 
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol ubcBlueBack"></span> 
      </div> 
    </section>
    <section class="sectionRow top65">
      <div class="col40ponto4">
        <img title="Fábio Geovane" alt="Fábio Geovane" src="../assets/imgs/fabio_geovane.jpg" />
      </div>
      <div class="col49">
        <p>Como bem já disse nosso CEO, Marcelo Castello Branco, o ano de 2022 foi de comemoração dos 80 anos de criação da UBC, mas também de recorde de distribuição para os titulares UBC e para aqueles que representamos através de nossos contratos de representação.</p>

        <p>Todo esse crescimento só pode acontecer se tivermos uma infraestrutura tecnológica robusta para suportar um volume gigantesco de informação e uma equipe de colaboradores que possa dar conta de todo esse trabalho.</p>

        <p>Os desafios atuais de segurança e volume de dados são sempre levados em consideração para o investimento em tecnologia, e em 2022 a UBC investiu muito em segurança e em hardware para o suporte necessário ao nosso crescimento.</p>

        <p>Na parte de sistemas, o desenvolvimento é constante para atender à dinâmica das necessidades das equipes da UBC e dos nossos associados e parceiros.</p>

        <p>Com relação à distribuição do ano de 2022, após a pandemia os números de distribuição referentes às rubricas de  Show, Carnaval, Música ao Vivo e Casa de Festas e Diversão tiveram uma expansão enorme, impulsionando nosso crescimento.</p>

        <h4 class="h4Destaque ubcBlue sanukBlack top32">“Fizemos um esforço de desenvolvimento de sistema e de processos que resultou em um excelente crescimento”</h4>

        <p class="top32">Com relação às demais rubricas, chamo a atenção para o contínuo crescimento de Streaming de audiovisual (+63,10%) e Streaming de áudio (+47,43%), na distribuição UBC comparada ao ano de 2021.</p>

        <p>Outra evolução grande que tivemos nos números da UBC foi referente à distribuição dos valores de direito conexo vindo das associações estrangeiras, pois fizemos um esforço de desenvolvimento de sistema e de processos que resultou em um excelente crescimento, refletindo-se numa maior distribuição para os titulares da UBC.</p>

        <p>Por fim, a UBC e toda sua equipe vêm trabalhando para entregar o melhor resultado possível para seus titulares, olhando para o futuro e observando o que de mais moderno e eficiente existe disponível no mercado, com o objetivo de prestar um serviço de excelência para aqueles que confiam em nós.</p>
        <br />
        <p class="ubcBlue sanukBold">Fabio Geovane</p>
      </div>
    </section>  
    </div>
  </div>
  </template>
  
  <script>
  import { ShareFunctions } from '../assets/js/functions.js'

  export default {
    name: 'AnaliseDiretorDeOperacoes',
    props:['clicked'],
  
    data() {
      return{
        setaScrollState: false,
      }
    },
    mounted() {
      const conteudo = document.querySelector('#diretor-operacoes')
      conteudo.addEventListener('scroll', ShareFunctions.headerScroll)
    },
    methods: {
      goNext: function(){
        this.$emit("go-next");
      },
      goBack: function(){
        this.$emit("go-back");
      }, 
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .col40ponto4 img{
    width: 100%;
    max-width: 481px;
  }

  @media screen and ( max-width: 800px ) {
    .col40ponto4 img{
      margin-bottom: 32px;
    }
  }
  </style>